export const actionTypes = {
  GET_PARTNERS: "GET_PARTNERS",
  SET_PARTNERS: "SET_PARTNERS",

  SAVE_PARTNERS: "SAVE_PARTNERS",
  UPDATE_PARTNERS: "UPDATE_PARTNERS",

  GET_COMPANY: "GET_COMPANY",
  SET_COMPANY: "SET_COMPANY",

  GET_PARTNER_TYPES: "GET_PARTNER_TYPES",
  SET_PARTNER_TYPES: "SET_PARTNER_TYPES",

  GET_DISTRIBUTOR_OPTIONS: "GET_DISTRIBUTOR_OPTIONS",
  SET_DISTRIBUTOR_OPTIONS: "SET_DISTRIBUTOR_OPTIONS", 
};

export const actions = {
  getPartners: (payload) => ({
    type: actionTypes.GET_PARTNERS,
    payload: payload,
  }),

  setPartners: (payload) => ({
    type: actionTypes.SET_PARTNERS,
    payload: payload,
  }),

  savePartners: (payload) => ({
    type: actionTypes.SAVE_PARTNERS,
    payload: payload,
  }),

  updatePartners: (payload) => ({
    type: actionTypes.UPDATE_PARTNERS,
    payload: payload,
  }),

  getCompany: (payload) => ({
    type: actionTypes.GET_COMPANY,
    payload: payload,
  }),

  setCompany: (payload) => ({
    type: actionTypes.SET_COMPANY,
    payload: payload,
  }),

  getPartnerTypes: (payload) => ({
    type: actionTypes.GET_PARTNER_TYPES,
    payload: payload,
  }),

  setPartnerTypes: (payload) => ({
    type: actionTypes.SET_PARTNER_TYPES,
    payload: payload,
  }),

  getDistributorOptions: (payload) => ({
    type: actionTypes.GET_DISTRIBUTOR_OPTIONS,
    payload: payload,
  }),

  setDistributorOptions: (payload) => ({
    type: actionTypes.SET_DISTRIBUTOR_OPTIONS,
    payload: payload,
  }),
};
